import React, { Component } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import authStore from '../../Auth/AuthStore'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import mainStore from '../../../MainStore';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default class SuggestionCommentBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            editComment: '',
            comments: [],
            commentId: '',
            isCommentEdited: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.editComment = this.editComment.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentWillMount() {
        if (!this.props.suggestionId) return;
        let scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/GetComment?suggestionId=' + this.props.suggestionId + '&sessionId' + this.props.sessionId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleCommentChange(data) {
        this.setState({ "comment": data });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ "comment": data });
        }
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ [name]: evt.target.value });
        }
    }

    handleSave() {
        var scope = this;
        if (!this.state.comment && !this.state.editComment) return;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/AddComment', {
            method: 'POST',
            body: JSON.stringify({ Text: this.state.comment, workId: this.props.suggestionId, SessionId: this.props.sessionId, commentId: this.state.commentId, editComment: this.state.editComment }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var comments = scope.state.comments.slice(0);
                    var index = comments.findIndex(c => c.id === result.id)
                    if (index > -1) {
                        comments.splice(index, 1, result);
                    }
                    else {
                        comments.push(result);
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: comments, comment: '', commentId: '', isCommentEdited: false, editComment: '' });
                    if (scope.props.handleParentChange) {
                        scope.props.handleParentChange({ 'comment': '' });
                    }
                }).catch((err) => console.log(err));
            }
        });
    }

    editComment = comment => () => {
        this.setState({ commentId: comment.id, editComment: comment.text, isCommentEdited: true });
    }

    handleClose() {
        this.setState({ commentId: '', isCommentEdited: false, editComment: '' });
    }

    render() {
        var comments = this.state.comments && this.state.comments.map(c =>
            <Card key={c.id} className="comment-card">
                <CardContent>
                    <Typography color="textSecondary" gutterBottom>
                        {c.userName} {c.isEdited ? "edit at" : "at"} {c.isEdited ? c.editDate : c.date} {authStore.getUserId === c.userId && <IconButton onClick={this.editComment(c)} size="large"><EditIcon /></IconButton>}
                    </Typography>
                    <Typography variant="body2" component="p">
                        {c.text.split('\n').map(t => <div>{t}</div>)}
                    </Typography>
                </CardContent>
                {false && <CardActions>
                    <Button size="small">Edit</Button>
                </CardActions>}
            </Card>);
        return (
            <div className="full-width">
                <div className="fixed-heigth comment-list-wrapper">
                    {comments}
                </div>

                <TextField required
                    id="standard-required"
                    label="Новый комментарий"
                    fullWidth
                    margin="normal"
                    value={this.state.comment}
                    multiline
                    onKeyDown={(e) => e.keyCode === 13 && e.ctrlKey && this.handleSave()}
                    onChange={this.handleChange('comment')}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton size="small" onClick={this.handleSave}>
                                    <SendIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <Dialog
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="lg"
                    onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.state.isCommentEdited}>
                    <div className="edit-comment-dialog-inner">
                        <TextField required
                            id="standard-required"
                            label="Редактирование комментария"
                            fullWidth
                            margin="normal"
                            value={this.state.editComment}
                            multiline
                            onKeyDown={(e) => e.keyCode === 13 && e.ctrlKey && this.handleSave()}
                            onChange={this.handleChange('editComment')}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={this.handleSave}>
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                </Dialog>
            </div>
        );
    }
}
